import { CSSObject } from '@chakra-ui/react';

export const TextFormInfo: CSSObject = {
  color: 'gray.500',
  fontWeight: 'medium',
};
